export const TEXT_POSITION = Object.freeze({
	TOP: 'top',
	BOTTOM: 'bottom',
})

export const CONTENT_DIRECTION = Object.freeze({
	top: 'desc',
	bottom: 'asc',
})

export const CTA_VARIANTS = Object.freeze({
	VARIANT_1: 'cta-1',
	VARIANT_2: 'cta-2',
	VARIANT_3: 'cta-3',
	VARIANT_4: 'cta-4',
	VARIANT_5: 'cta-5',
	VARIANT_6: 'cta-6',
	VARIANT_7: 'cta-7',
	VARIANT_8: 'cta-8',
	VARIANT_9: 'cta-9',
	VARIANT_10: 'cta-10',
	VARIANT_12_13: 'cta-12_13',
	VARIANT_14: 'cta-14',
	VARIANT_15: 'cta-15',
	VARIANT_16_17: 'cta-16_17',
	VARIANT_18: 'cta-18',
})
